import React from 'react';
import { IconProps } from '.';

const SvgColoredConfetti = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#23AE50'
        d='M20.625 5.06c-.69 0-1.33.27-1.92.8l-5.09 5.099a.736.736 0 0 0 1.041 1.042l5.079-5.06c.25-.25.55-.38.89-.38.34 0 .64.13.89.38l.067.066a.75.75 0 0 0 1.073-.013l.016-.016a.75.75 0 0 0 .01-1.025l-.086-.093c-.59-.53-1.25-.8-1.97-.8Z'
      />
      <path
        fill='#FF7E07'
        d='M18.625 11.06c-.7 0-1.34.27-1.94.8l-1.06 1.06a.75.75 0 0 0 0 1.06l.02.02a.75.75 0 0 0 1.06 0l1.06-1.06c.25-.25.53-.38.86-.38.33 0 .63.13.88.38l1.1 1.08a.743.743 0 0 0 1.052-1.05l-1.082-1.11c-.59-.53-1.25-.8-1.95-.8Z'
      />
      <path
        fill='#F05046'
        d='M14.685 1.98a.75.75 0 0 0-1.06 0l-.02.02a.75.75 0 0 0 0 1.06l1.07 1.07c.22.25.33.54.33.87 0 .33-.11.64-.33.86L11.62 8.967a.74.74 0 0 0 1.048 1.043l3.087-3.07c.53-.59.79-1.24.79-1.94s-.26-1.36-.79-1.95l-1.07-1.07Z'
      />
      <path
        fill='#4769F7'
        d='M10.703 3.998a.747.747 0 1 0-1.033 1.08l.035.032c.22.22.33.52.33.89s-.11.67-.33.89l-.047.044a.732.732 0 1 0 1.033 1.033l.044-.047c.53-.59.8-1.23.8-1.92 0-.72-.27-1.37-.8-1.97l-.032-.032Z'
      />
      <path
        fill='#FFC700'
        d='M8.158 9.176a1.5 1.5 0 0 0-2.473.556L2.19 19.518c-.426 1.192.725 2.343 1.917 1.917l9.786-3.495a1.5 1.5 0 0 0 .556-2.473l-6.29-6.291Z'
      />
    </svg>
  );
};

export default SvgColoredConfetti;
